import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "We help brands show up consistently and meaningfully across social platforms — with a clear strategy, content that fits each channel and campaigns aimed at real business outcomes.",
    "From organic community building to paid social, we focus on the platforms and formats where your audience actually spends time.",
];

const FEATURES = [
    { title: "Channel strategy", text: "The right platforms, cadence and voice for your audience and goals." },
    { title: "Content that fits", text: "Formats tailored to each network, not the same post copied everywhere." },
    { title: "Paid social campaigns", text: "Targeted ad spend with tracking, so every rupee is accountable." },
    { title: "Community management", text: "Consistent engagement that builds trust and keeps you top of mind." },
];

const CHECKS = [
    "Social strategy & planning",
    "Content creation",
    "Paid social advertising",
    "Community management",
    "Performance reporting",
];

export default function SocialMedia() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Digital Marketing" title="Social Media Marketing" eyebrowAs="span">
                    Build an audience and keep it — social strategy, content and campaigns that turn followers into customers.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
